var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/wallet-connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0.0003125%",
    cy: "50.0015625%",
    fx: "0.0003125%",
    fy: "50.0015625%",
    r: "100%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/wallet-connect",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "walletconnect-seeklogo.com"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2851562,0 30,6.71484375 30,15 C30,23.2851562 23.2851562,30 15,30 C6.71484375,30 0,23.2851562 0,15 C0,6.71484375 6.71484375,0 15,0 Z",
    id: "Path",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53320312,11.5839844 C12.5507812,8.63671875 17.4492187,8.63671875 20.4667969,11.5839844 L20.8300781,11.9414063 C20.9824219,12.0878906 20.9824219,12.328125 20.8300781,12.4746094 L19.5878906,13.6875 C19.5117187,13.7636719 19.3886719,13.7636719 19.3125,13.6875 L18.8144531,13.2011719 C16.7050781,11.1445313 13.2949219,11.1445313 11.1855469,13.2011719 L10.6523437,13.7226562 C10.5761719,13.7988281 10.453125,13.7988281 10.3769531,13.7226562 L9.13476562,12.5097656 C8.98242187,12.3632813 8.98242187,12.1230469 9.13476562,11.9765625 L9.53320312,11.5839844 Z M23.0390625,14.0917969 L24.1464844,15.1699219 C24.2988281,15.3164063 24.2988281,15.5566406 24.1464844,15.703125 L19.1601562,20.5722656 C19.0078125,20.71875 18.7617188,20.71875 18.6152344,20.5722656 C18.6152344,20.5722656 18.6152344,20.5722656 18.6152344,20.5722656 L15.0761719,17.1152344 C15.0410156,17.0800781 14.9765625,17.0800781 14.9414062,17.1152344 C14.9414062,17.1152344 14.9414062,17.1152344 14.9414062,17.1152344 L11.4023438,20.5722656 C11.25,20.71875 11.0039062,20.71875 10.8574219,20.5722656 C10.8574219,20.5722656 10.8574219,20.5722656 10.8574219,20.5722656 L5.85351562,15.703125 C5.70117188,15.5566406 5.70117188,15.3164063 5.85351562,15.1699219 L6.9609375,14.0917969 C7.11328125,13.9453125 7.359375,13.9453125 7.50585938,14.0917969 L11.0449219,17.5488281 C11.0800781,17.5839844 11.1445312,17.5839844 11.1796875,17.5488281 C11.1796875,17.5488281 11.1796875,17.5488281 11.1796875,17.5488281 L14.71875,14.0917969 C14.8710937,13.9453125 15.1171875,13.9453125 15.2636719,14.0917969 C15.2636719,14.0917969 15.2636719,14.0917969 15.2636719,14.0917969 L18.8027344,17.5488281 C18.8378906,17.5839844 18.9023437,17.5839844 18.9375,17.5488281 L22.4765625,14.0917969 C22.640625,13.9453125 22.8867188,13.9453125 23.0390625,14.0917969 L23.0390625,14.0917969 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.561c10c42f71e9afa2630c46c759292b.svg";
export { ForwardRef as ReactComponent };